import * as yup from 'yup';

const booleanSelector = {
  base: yup.mixed()
};
booleanSelector.required = booleanSelector.base.oneOf(['true', 'false']);
booleanSelector.optional = booleanSelector.base.oneOf(['true', 'false', '']);

export default booleanSelector;
